<template>
  <v-card>
    <v-card-title class="headline">
      <v-icon>check</v-icon>
      Aprobar Movilidad
      <v-spacer />
      <v-btn icon @click="close()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex md12>
              <strong>Tipo de movilidad:</strong>
              {{ movilidad.tipo_movimiento }}
            </v-flex>
            <v-flex md12>
              <strong>Servidor público:</strong>
              {{ movilidad.funcionario.nombre }}
            </v-flex>
            <v-flex md6>
              <strong>Item:</strong> {{ movilidad.nro_item }}
            </v-flex>
            <v-flex md6>
              <strong>Fecha desde:</strong> {{ movilidad.fecha_desde }}
            </v-flex>
            <v-flex md6>
              <v-text-field
                v-if="!cargoEspecial"
                label="Nro memorándum"
                v-model="form.nro_memorandum"
                maxlength="200"
                :rules="$validate(['required'])"
                required
                :loading="loading"
                :disabled="loading"
              ></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field
                v-if="!cargoEspecial"
                v-model="form.fecha_memorandum"
                :rules="$validate(['required'])"
                required
                label="Fecha de memorándum"
                type="date"
                :loading="loading"
                @input="esFeriadoOFinDeSemana(form.fecha_memorandum, 1)"
                :disabled="loading"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" :loading="loading" @click="aprobarRechazar(1)">
          <v-icon>check</v-icon> Aprobar
        </v-btn>
        <v-btn color="error" :loading="loading" @click="aprobarRechazar(0)">
          <v-icon>clear</v-icon> Rechazar
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
export default {
  mixins: [validate],
  props: ["movilidad"],
  data() {
    return {
      loading: true,
      form: {},
      valid: false,
      nro_resolucion: null,
      fecha_resolucion: null,
      cargoEspecial: false,
      prueba: this.comprobarCargoEspecial(),
      bandera_fecha: false,
    };
  },
  methods: {
    close() {
      this.$bus.$emit("closeDialogAprobar");
    },
    async esFeriadoOFinDeSemana(fecha,valor){},
    async esFeriadoOFinDeSemanaVerificar(fecha, valor) {
      try {
        if (valor == 1) {
          this.bandera_fecha = false;
        }
        let usuario = this.$storage.get("user");
        if (!fecha && valor == 1) {
          this.$message.info("Fecha inválida ", fecha);
          this.bandera_fecha = true;
          return true;
        } else {
          //verificando que la fecha es o no dia habil
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
                  respuesta
                }
              }
            `,
          });
          if (respuesta.runQuery.respuesta) {
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_cuenta_finde_feriado_por_persona;

            if (respuesta == 1 && valor == 1) {
              this.$message.info(
                `La fecha ${this.$moment(fecha).format(
                  "DD/MM/YYYY"
                )} cae en fin de semana o feriado`
              );
              this.bandera_fecha = true;
              return true;
            }

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    //    async esFeriadoOFinDeSemana(fecha) {
    //   console.log(fecha, "+-+-+---");

    //   try {
    //     if (fecha.substring(0, 1) == "2") {
    //       let usuario = this.$storage.get("user");
    //       this.bandera_fecha = false;
    //       //verificando que la fecha es o no invalida
    //       let respuesta2 = await this.$service.graphql({
    //         query: `
    //           query{
    //             runQuery(consulta: "SELECT general.fn_valida_fecha('${this.$moment(
    //               fecha,
    //               "YYYY-MM-DD"
    //             )}')"){
    //               respuesta
    //             }
    //           }
    //         `,
    //       });
    //       respuesta2 = respuesta2.runQuery.respuesta[0].fn_valida_fecha;
    //       let rpta = respuesta2.split("|");

    //       if (respuesta2.split("|")[0] == 1) {
    //         //verificando que la fecha es o no dia habil
    //         let respuesta = await this.$service.graphql({
    //           query: `
    //           query{
    //             runQuery(consulta: "SELECT general.fn_cuenta_finde_feriado_por_persona('${fecha}', '${fecha}', ${usuario.id_persona})"){
    //               respuesta
    //             }
    //           }
    //         `,
    //         });
    //         if (respuesta.runQuery.respuesta) {
    //           respuesta =respuesta.runQuery.respuesta[0].fn_cuenta_finde_feriado_por_persona;

    //           if (respuesta == 1) {
    //             this.$message.info("La fecha cae en fin de semana o feriado");
    //             this.bandera_fecha = true;
    //             return;
    //           }
    //         } else {
    //          // this.$message.info("La fecha es invalida");
    //         }
    //       } else {
    //         //this.$message.info("La fecha es invalida");
    //       }
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },

    async comprobarCargoEspecial() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_pregunta_cargo_vice_direc_por_item(${parseInt(
                this.movilidad.nro_item
              )})"){
                respuesta
              }
            }
          `,
        });
        res = res.runQuery.respuesta[0].fn_pregunta_cargo_vice_direc_por_item;
        res = res.split("|");
        if (parseInt(res[0]) == 1) {
          if (res[1] == "SI") {
            this.cargoEspecial = true;
          }
          this.loading = false;
        } else {
          this.$message.error(res[1]);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async aprobarRechazar(tipo) {
      if (tipo == 1) {
        if (this.$refs.form.validate()) {
          try {
            if (this.form.fecha_memorandum) {
              let validacion_fecha = await this.esFeriadoOFinDeSemanaVerificar(
                this.form.fecha_memorandum,
                1
              );
              if (validacion_fecha) {
                return;
              }
            }
            this.loading = true;
            let resps = [];
            let user = this.$storage.get("user");
            let temp = this.$moment(
              this.movilidad.fecha_desde,
              "DD/MM/YYYY"
            ).format("YYYY-MM-DD");
            if (this.cargoEspecial) {
              this.form.fecha_memorandum = null;
              this.form.nro_memorandum = null;
            }
            if (this.form.fecha_memorandum != null) {
              this.form.fecha_memorandum = `'${this.form.fecha_memorandum}'`;
            }
            if (this.form.nro_memorandum != null) {
              this.form.nro_memorandum = `'${this.form.nro_memorandum}'`;
            }
            console.log(`
            query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_rechaza_movilidad(${this.movilidad.funcionario.id_persona}, ${user.id}, ${tipo}, '${temp}',${this.form.nro_memorandum},${this.form.fecha_memorandum},null,null)"){
              respuesta
              }
            }
          `);
            let res = await this.$service.graphql({
              query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_rechaza_movilidad(${this.movilidad.funcionario.id_persona}, ${user.id}, ${tipo}, '${temp}',${this.form.nro_memorandum},${this.form.fecha_memorandum},null,null)"){
              respuesta
              }
            }
          `,
            });
            res = res.runQuery.respuesta[0].fn_aprueba_rechaza_movilidad;
            resps = res.split("|");
            let correcto = resps[0];
            if (correcto === "1") {
              this.$message.success();
            } else {
              this.$message.error(resps);
            }
            this.loading = false;
            this.close();
          } catch (error) {
            console.log(error);
          }
        }
      } else {
        try {
          this.loading = true;
          let resps = [];
          let user = this.$storage.get("user");
          let temp = this.$moment(
            this.movilidad.fecha_desde,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          let res = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta: "SELECT movilidad.fn_aprueba_rechaza_movilidad(${this.movilidad.funcionario.id_persona}, ${user.id}, ${tipo}, '${temp}',null,null,null,null)"){
              respuesta
              }
            }
          `,
          });
          res = res.runQuery.respuesta[0].fn_aprueba_rechaza_movilidad;
          resps = res.split("|");
          let correcto = resps[0];
          if (correcto === "1") {
            this.$message.success();
          } else {
            this.$message.error(resps);
          }
          this.loading = false;
          this.close();
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/movilidad/components/AprobarComisionServicio.vue